"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_TAG_TO_SPECIAL_OFFERS_TABS_MAP = void 0;
const helpers_1 = require("./helpers");
const lists_1 = require("./lists");
const PRODUCT_TAG_TO_SPECIAL_OFFERS_TABS_MAP_DRAFT = {
    vklady: [lists_1.COMMON_OFFERS.savings, lists_1.COMMON_OFFERS.accumulative],
    kredity: [lists_1.COMMON_OFFERS.credits],
    'kredity/onlajn-zayavka-na-kredit': [lists_1.COMMON_OFFERS.credits],
    'onlajn-zayavka-na-kredit': [lists_1.COMMON_OFFERS.credits],
    ipoteka: [lists_1.COMMON_OFFERS.mortgage],
    karty: [lists_1.COMMON_OFFERS.creditCards, lists_1.COMMON_OFFERS.debitCards],
    'debetovye-karty': [lists_1.COMMON_OFFERS.debitCards],
    zaimy: [lists_1.COMMON_OFFERS.loan],
    'zaimy/onlain': [lists_1.COMMON_OFFERS.loan],
    'brokerskoe-obsluzhivanie': [lists_1.COMMON_OFFERS.brokerskoeObsluzhivanie],
    bankrotstvo: [lists_1.COMMON_OFFERS.bankrotstvo],
    osago: [lists_1.INSURANCE_OFFERS.insuranceOsago],
    dms: [lists_1.INSURANCE_OFFERS.dms],
    'strahovka-kriticheskie-bolezni': [lists_1.INSURANCE_OFFERS['strahovka-kriticheskie-bolezni']],
    // 'strahovka-ot-klescha': [INSURANCE_OFFERS['strahovka-ot-klescha']],
    'strahovanie-domov': [lists_1.INSURANCE_OFFERS['strahovanie-domov']],
    avtokredity: [lists_1.INSURANCE_OFFERS.insuranceOsago],
    kursy: [{ type: lists_1.EDUCATION_OFFERS.learning, subtype: lists_1.LEARNING_TYPES.typeProgramming }],
    rko: [lists_1.BUSINESS_OFFERS.biznesRko],
    biznes: [lists_1.BUSINESS_OFFERS.biznesRko],
    'biznes-kredity': [lists_1.BUSINESS_OFFERS.biznesKredity],
    factoring: [lists_1.BUSINESS_OFFERS.biznesKredity],
    ekvajring: [lists_1.BUSINESS_OFFERS.biznesEkvajring],
    'bankovskie-garantii': [lists_1.BUSINESS_OFFERS.bankovskieGarantii],
    // 'biznes-vklady': [BUSINESS_OFFERS.biznesDepozit],
    'biznes-registration': [lists_1.BUSINESS_OFFERS.biznesRegistration],
    'biznes-accounting': [lists_1.BUSINESS_OFFERS.biznesAccounting],
    bukhgalteriyabiznes: [lists_1.BUSINESS_OFFERS.biznesAccounting],
    'biznes-marketplace': [lists_1.BUSINESS_OFFERS.biznesMarketplace],
    'biznes-na-marketpleysakh': [lists_1.BUSINESS_OFFERS.biznesMarketplace],
    'biznes-leasing': [lists_1.BUSINESS_OFFERS.biznesLeasing],
    'zarplatnyj-proekt': [lists_1.BUSINESS_OFFERS.zarplatnyjProekt],
    ved: [lists_1.BUSINESS_OFFERS.biznesVed],
};
exports.PRODUCT_TAG_TO_SPECIAL_OFFERS_TABS_MAP = Object.entries(PRODUCT_TAG_TO_SPECIAL_OFFERS_TABS_MAP_DRAFT).reduce((acc, [key, value]) => (Object.assign(Object.assign({}, acc), { [key]: (0, helpers_1.normalizeTabs)(value) })), {});
